import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './App.css';
import HomePage from './pages/HomePage';
import Login from './pages/Login';
import Signup from './pages/Signup';
import VerifyEmail from './pages/VerifyEmail';
import EmailVerificationResult from './pages/EmailVerificationResult';
import Dashboard from './pages/Dashboard';
import MatriceEditor from './pages/MatriceEditor';
import DocumentEditor from './pages/DocumentEditor';
import History from './pages/History';
import DocumentHistory from './pages/DocumentHistory';
import TheCircle from './pages/TheCircle';
import Profile from './pages/Profile';
import BlogPage from './pages/BlogPage';
import StoryPage from './pages/StoryPage';
import ContactPage from './pages/ContactPage';
import AnimatedTextEditor from './pages/AnimatedTextEditor';
import PrivateRoute from './components/PrivateRoute';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import './i18n';

function App() {
  const { i18n } = useTranslation();
  
  // Mettre à jour l'attribut lang du HTML quand la langue change
  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <div className="App">
            <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/story" element={<StoryPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/verify-email/:uidb64/:token" element={<EmailVerificationResult />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/matrice"
              element={
                <PrivateRoute>
                  <MatriceEditor />
                </PrivateRoute>
              }
            />
            <Route
              path="/matrice/edit/:id"
              element={
                <PrivateRoute>
                  <MatriceEditor />
                </PrivateRoute>
              }
            />
            <Route
              path="/document"
              element={
                <PrivateRoute>
                  <DocumentEditor />
                </PrivateRoute>
              }
            />
            <Route
              path="/history"
              element={
                <PrivateRoute>
                  <History />
                </PrivateRoute>
              }
            />
            <Route
              path="/document-history"
              element={
                <PrivateRoute>
                  <DocumentHistory />
                </PrivateRoute>
              }
            />
            <Route
              path="/thecircle"
              element={
                <PrivateRoute>
                  <TheCircle />
                </PrivateRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <PrivateRoute>
                  <Profile />
                </PrivateRoute>
              }
            />
            <Route
              path="/document/edit/:id"
              element={
                <PrivateRoute>
                  <DocumentEditor />
                </PrivateRoute>
              }
            />
            <Route
              path="/animated-editor"
              element={
                <PrivateRoute>
                  <AnimatedTextEditor />
                </PrivateRoute>
              }
            />
          </Routes>
          
          <a
            href="https://www.synestesia.world/"
            target="_blank"
            rel="noopener noreferrer"
            className="app-footer-link"
          >
            www.synestesia.world
          </a>
        </div>
      </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
